// Outlook API Service für Clara360
// Verbindet Frontend mit Outlook Backend auf Port 3005

const API_BASE_URL = 'http://localhost:3005';

class OutlookApiService {
  // Health Check
  async checkHealth() {
    try {
      const response = await fetch(`${API_BASE_URL}/health`);
      return await response.json();
    } catch (error) {
      console.error('Outlook Health Check failed:', error);
      return { success: false, error: error.message };
    }
  }

  // E-Mail Summary abrufen
  async getEmailSummary() {
    try {
      const response = await fetch(`${API_BASE_URL}/summary`);
      return await response.json();
    } catch (error) {
      console.error('Email Summary failed:', error);
      return { 
        success: false, 
        error: error.message,
        summary_date: new Date().toISOString().split('T')[0],
        new_emails: 0,
        total_emails: 0,
        high_priority: 0,
        with_attachments: 0,
        summary: 'E-Mail-Service temporär nicht verfügbar.',
        last_updated: new Date().toISOString()
      };
    }
  }

  // Mock-Daten für E-Mails (bis echte API verfügbar ist)
  async getEmails() {
    try {
      // Versuche echte Daten zu holen
      const summary = await this.getEmailSummary();
      
      if (summary.success) {
        return {
          success: true,
          emails: [
            {
              id: 'email_1',
              subject: summary.summary || 'E-Mail Zusammenfassung',
              sender: 'hiss@g-rn.de',
              preview: `${summary.new_emails} neue E-Mails, ${summary.high_priority} mit hoher Priorität`,
              timestamp: summary.last_updated,
              unread: summary.new_emails > 0,
              priority: summary.high_priority > 0 ? 'high' : 'normal'
            }
          ],
          total: 1
        };
      } else {
        // Fallback Mock-Daten
        return {
          success: true,
          emails: [
            {
              id: 'email_mock_1',
              subject: 'Willkommen bei Clara360 Outlook',
              sender: 'system@clara360.de',
              preview: 'Ihre Outlook-Integration ist bereit!',
              timestamp: new Date().toISOString(),
              unread: true,
              priority: 'normal'
            }
          ],
          total: 1
        };
      }
    } catch (error) {
      console.error('Get Emails failed:', error);
      return { success: false, error: error.message, emails: [], total: 0 };
    }
  }

  // E-Mail senden (Mock)
  async sendEmail(to, subject, body, context = {}) {
    try {
      const response = await fetch('http://localhost:5018/api/email/send', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ to, subject, body, context })
      });
      const result = await response.json();
      if (result.success) {
        return { success: true, message: 'E-Mail erfolgreich gesendet', messageId: result.messageId };
      } else {
        return { success: false, error: result.error || 'Unbekannter Fehler' };
      }
    } catch (error) {
      console.error('Send Email failed:', error);
      return { success: false, error: error.message };
    }
  }
}

export default new OutlookApiService();
